function backToTop() {
  const triggers = document.querySelectorAll<HTMLElement>('.js-back-to-top');
  if (!triggers.length) return;

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  triggers.forEach(el => {
    el.addEventListener('click', handleClick);
  });
}
backToTop();
